import { concurrency } from '@farfetched/core';
import { createInstance } from '@leprecoins/effector-query';
import { OverloadedParameters } from '@leprecoins/utility-types';
import { API_URL } from 'shared/config';
import { applyNotifications } from 'shared/lib';

const [createBaseQuery, createBaseMutation] = createInstance({
	url: API_URL,
	credentials: 'include',
});

export const createQuery: typeof createBaseQuery = (
	params: OverloadedParameters<typeof createQuery>[0],
) => {
	const query = createBaseQuery(params);

	concurrency(query, { strategy: 'TAKE_LATEST' });

	applyNotifications(query);

	return query;
};

export const createMutation: typeof createBaseMutation = (
	params: OverloadedParameters<typeof createMutation>[0],
) => {
	const mutation = createBaseMutation(params);

	applyNotifications(mutation);

	return mutation;
};
